module.exports = __webpack_public_path__ + "img/IMG_20191126_235448.899562bf.jpg";